import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import classes from './AlertSuccess.module.scss';

interface Props {
    message: string;
    icon?: IconDefinition;
    color?: string;
    bgColor?: string;
}

export const AlertSuccess: React.FC<Props> = ({
    message,
    icon = faCheckCircle,
    color = '#5E8677',
    bgColor = '#E6FFF2'
}) => {
    return (
        <div style={{ backgroundColor: bgColor, borderColor: color }}>
            <div className={classes.header}>
                <FontAwesomeIcon icon={icon} className={classes.icon} style={{ color: color }} />
                <span className={classes.message}>{message}</span>
            </div>
        </div>
    );
};
